import React from 'react';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import './summary.scss';

export const ReadModelSummary = (props) => {
  const {name, count} = props.readModel;

  return (
    <Card className='summary'>
      <CardContent>
        <h2 className='summary__title'>{name}</h2>
        <ul className='summary__details'>
          <li><em>Count:</em> {count}</li>
        </ul>

      </CardContent>
      <CardActions>
        <Button size='small' disabled={true}>More details</Button>
      </CardActions>
    </Card>
  )
}
